<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
    },
    hoverEffect: {
      type: Boolean,
    },
  },
  data() {
    return {
      defaultPicture: require('@assets/images/logo-icon.svg'),
      errorLoading: false,
    }
  },
  computed: {
    picturePath() {
      if (this.errorLoading) {
        return this.defaultPicture
      }
      return this.src || this.defaultPicture
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.profilePictureImgWrapper]: true,
      [$style.active]: active,
      [$style.profilePictureImgHoverEffect]: hoverEffect,
    }">
    <img :src="picturePath" :class="{ [$style.profilePictureImg]: true }" @error="errorLoading = true" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

$profile-picture-size: 48px;
$profile-picture-size-mobile: 32px;

.profilePictureImgWrapper {
  @media (max-width: $lg-breakpoint) {
    width: $profile-picture-size-mobile;
    height: $profile-picture-size-mobile;
  }

  width: $profile-picture-size;
  height: $profile-picture-size;
  margin-bottom: 4px;
  overflow: hidden;
  border-radius: 50%;
}

.profilePictureImg {
  width: 100%;
  height: 100%;
  vertical-align: top;
  transform: scale(1.05);
  object-fit: cover;
}

.profilePictureImgHoverEffect {
  &:hover {
    filter: brightness(90%);
  }
}

.active {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 1), 0 0 0 4px $primary-blue;
}
</style>
